// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2nhzZ","title":"BackImages_title__LQb1j","images":"BackImages_images__3lx2s"};